import { create } from 'zustand';

import type { NavbarProps } from './Navbar';

interface NavbarState {
  navbarProps: NavbarProps
  setNavbarProps: (props: NavbarProps) => void
}

export const useNavbar = create<NavbarState>(
  (set) => ({
    navbarProps: {} as NavbarProps,
    setNavbarProps: (navbarProps: NavbarProps) => set({
      navbarProps,
    }),
  }),
);

interface TogglesState {
  openId?: string
  setOpenId: (id: string) => void
  closeToggle: () => void
}

export const useToggles = create<TogglesState>(
  (set) => ({
    openId: undefined,
    setOpenId: (id: string) => set(
      (state: any) => {
        if (state.openId === id) {
          return { openId: undefined };
        }

        return { openId: id };
      },
    ),
    closeToggle: () => set({
      openId: undefined,
    }),
  }),
);

interface TokenState {
  token: string
  fetchToken: () => Promise<void>
}

export const useToken = create<TokenState>(
  (set) => ({
    token: '',
    fetchToken: async () => {
      const navbarState = useNavbar?.getState();

      const token = await navbarState?.navbarProps?.getToken?.();

      set({ token });
    },
  }),
);
